export default "__VITE_ASSET__Bw13c9lk__"